import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@skynet/theme-provider';
import { selectThemeName } from '../store/selectors';
import type { ThemeStore } from '../store/selectors';

interface ThemeWrapperProps {
  children: ReactNode;
}

export function ThemeWrapper({ children }: ThemeWrapperProps) {
  const themeName = useSelector((state: ThemeStore) => selectThemeName(state));
  return <ThemeProvider themeName={themeName}>{children}</ThemeProvider>;
}
